import React, {useState} from 'react';
import {Drawer} from "antd";
import {PlusOutlined} from '@ant-design/icons';

import './styles.scss';
import Button from "../../common/Button/Button";
import VendorForm from "./VendorForm";

interface Props {
    className?: string,
    onSubmit?: (values: string) => void,
}

function VendorFormModalAsButton(props: Props) {
    const {className, onSubmit} = props;
    const [showForm, setShowForm] = useState(false);

    const onButtonClick = async (e: any) => {
        e.stopPropagation();
        setShowForm(true);
    }

    const onFormSubmit = async (values: any) => {
        if (onSubmit) await onSubmit(values);
        setShowForm(false);
    }

    return (
        <div onClick={e => e.stopPropagation()}>
            <Button icon={<PlusOutlined/>} className={className} onClick={onButtonClick}>
                Create Vendor
            </Button>
            <Drawer title='Create Vendor' width='50%' keyboard={false} open={showForm} destroyOnClose
                    onClose={() => setShowForm(false)}
                    className='vendors-form-drawer' footer={null}>
                <VendorForm applyDrawerStyles onSubmit={onFormSubmit}/>
            </Drawer>
        </div>
    )
}

export default VendorFormModalAsButton;